import { render, staticRenderFns } from "./SelfInductionViz.vue?vue&type=template&id=33d8c8a8&scoped=true"
import script from "./SelfInductionViz.vue?vue&type=script&lang=js"
export * from "./SelfInductionViz.vue?vue&type=script&lang=js"
import style0 from "./SelfInductionViz.vue?vue&type=style&index=0&id=33d8c8a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8c8a8",
  null
  
)

export default component.exports